import { render, staticRenderFns } from "./RatingCard.vue?vue&type=template&id=0fb92e98&scoped=true&"
import script from "./RatingCard.vue?vue&type=script&lang=js&"
export * from "./RatingCard.vue?vue&type=script&lang=js&"
import style0 from "./RatingCard.vue?vue&type=style&index=0&id=0fb92e98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb92e98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
